module.exports = __webpack_public_path__ + "img/fij cannes 2024.593a4d8d.webp";